import React from "react";
import EasyTrans from "../../components/bundel/EasyTrans";
import { Card, PageContainer } from "../../components/ui";

const Certificates = () => {
  return (
    <PageContainer>
      <Card bodyClassName="overflow-x-auto">
        <table className="w-full text-sm text-left text-gray-500">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
              <th scope="col" className="py-3 px-6">
                <EasyTrans>Settings.Certificates.Name</EasyTrans>
              </th>
              <th scope="col" className="py-3 px-6">
                <EasyTrans>Settings.Certificates.Date</EasyTrans>
              </th>
              <th scope="col" className="py-3 px-6">
                <EasyTrans>Settings.Certificates.Worktype</EasyTrans>
              </th>
              <th scope="col" className="py-3 px-6">
                <EasyTrans>Settings.Certificates.Download</EasyTrans>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-white border-b">
              <th
                scope="row"
                className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap"
              >
                Licence one
              </th>
              <td className="py-4 px-6">Licence two</td>
              <td className="py-4 px-6">Licence three</td>
              <td className="py-4 px-6">Licence four</td>
            </tr>
            <tr className="bg-white border-b">
              <th
                scope="row"
                className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap"
              >
                Microsoft Surface Pro
              </th>
              <td className="py-4 px-6">White</td>
              <td className="py-4 px-6">Laptop PC</td>
              <td className="py-4 px-6">$1999</td>
            </tr>
            <tr className="bg-white">
              <th
                scope="row"
                className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap"
              >
                Magic Mouse 2
              </th>
              <td className="py-4 px-6">Black</td>
              <td className="py-4 px-6">Accessories</td>
              <td className="py-4 px-6">$99</td>
            </tr>
          </tbody>
        </table>
      </Card>
    </PageContainer>
  );
};

export default Certificates;
